var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"tw-flex tw-justify-end tw-text-[#b3b9c6]"},[_c('div',[_c('span',{staticClass:"tw-font-poppins"},[_vm._v("Presented by")]),_vm._v(" "),_c('span',{staticClass:"tw-font-georgia"},[_vm._v(_vm._s(_vm.advisorStore.advisor?.firm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }